import {
    FormControlLabel,
    RadioGroup,
    FormControl,
    FormLabel,
    Radio,
    RadioGroupProps,
    FormHelperText,
    Theme,
} from '@mui/material'
import { SxProps } from '@mui/system'
import { ReactNode } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'
import { TOption } from './OWSelect'
import useReactHookFormError from './useReactHookFormError'

function OWRadio<T extends object>(
    props: RadioGroupProps &
        UseControllerProps<T> & {
            options: TOption[]
            hasEmpty?: boolean
            disabled?: boolean
            spacing?: number
        } & {
            label?: ReactNode
            labelID?: string
            radioSx?: SxProps<Theme> | undefined
        },
) {
    const {
        name,
        control,
        options,
        label,
        labelID,
        disabled,
        color,
        radioSx,
        spacing = 2,
        ...otherProps
    } = props

    const {
        field,
        formState: { errors },
    } = useController<T>({ name, control })

    const { ref, ...otherFields } = field

    const error = useReactHookFormError(errors, name)

    const pickedTextFieldObj = (({ sx }) => ({ sx }))(props)

    const generateRadioOptions = () => {
        return options.map((singleOption) => (
            <FormControlLabel
                sx={{ pr: spacing }}
                key={singleOption.value}
                value={singleOption.value}
                label={singleOption.label}
                control={<Radio color={color as any} sx={radioSx} />}
            />
        ))
    }

    return (
        <FormControl
            {...pickedTextFieldObj}
            error={error && error.error}
            disabled={disabled}
        >
            <FormLabel id={labelID}>{label}</FormLabel>
            <RadioGroup {...otherFields} {...otherProps}>
                {generateRadioOptions()}
            </RadioGroup>
            {error && error.error && (
                <FormHelperText>{error.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

export default OWRadio
